<template>
    <v-container fluid class="pa-4 meaning-content text-left">
        <v-row justify="start" align="start" v-if="data">
            <v-col cols="12" class="meaning--header pt-0 text-uppercase font-size-12">
                <img :src="dictionaryImg" class="img-index mr-1 align-middle" alt="" />
                {{ $t('bookReading.dictionary') }}
            </v-col>
            <v-col cols="12">
                <span
                    class="font-size-16 text-capitalize primary--text darken-3 font-weight-bolder text-left"
                >
                    {{data.word}} 
                </span>
            </v-col>
            <v-col cols="12" class="pt-0 pb-0">
                <em class="meaning--meaning">{{ meaning }}</em>
            </v-col>
            <v-col
                cols="12"
                class="px-3 pt-0 pb-0 d-flex flex-column align-center justify-center"
                v-for="(def, index) of data.definitions"
                :key="index"
            >
                <div class="w-100 d-flex flex-column justify-center">
                    <div class="row">
                        <div class="col-auto pb-2 pt-1 pr-0">
                            <span class="font-size-18 line-height-100 lighten-3 text-justify">
                                {{ index + 1 }}. 
                            </span>
                        </div>
                        <div class="col-11 pb-2 pt-1 pl-1 text-left">
                            <!-- <b>{{ $t('bookReading.example') }}:</b> {{ def.examples[0].text }} -->
                            <p class="mb-0">{{ def.definitions[0] }}</p>
                            <span 
                                class="text-body-1 lighten-3 meaning--example"
                                v-if="def.examples"
                            >
                                "{{ def.examples[0].text }}"
                            </span>
                        </div>
                    </div>


                    <!-- <div class="col-auto">
                        {{ index + 1 }}.
                    </div>
                    <div class="col-auto flex-fill">
                        <div class="row">
                            <div class="col-12">
                                {{ def.definitions[0] }}
                            </div>
                            <div class="col-12">
                                "{{ def.examples[0].text }}"
                            </div>
                        </div>
                    </div> -->
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
export default {
    props: {
        data: { type: Object, default: null },
    },
    computed: {
        meaning() {
            const value = this.wordClassification.hasOwnProperty(this.data.name)
                ? `${this.$t(`dictionary.${this.wordClassification[this.data.name]}`)}`
                : '' ;
            // return `${this.data.word} ${value}`;
            return `${value}`;
        },
    },
    data() {
        return {
            dictionaryImg: require('@/assets/img/icons/new-reading/icon-dictionary.svg'),
            wordClassification : {
                Noun: 'noun',
                Article: 'article',
                Adjective: 'adjective',
                Pronoun: 'pronoun',
                Verb: 'verb',
                Adverb: 'adverb',
                Preposition: 'proposition',
                Conjunction: 'conjunction',
                Interjection: 'interjection',
                Numeral: 'numeral'
            },
       }
    }
}
// definitions: Array(4) // meaning: "verbo transitivo" // origin: undefined // word: "buscar"
</script>
<style lang="scss">
.meaning{
    &-content{
        background: #F0F2F4;
        border-radius: 6px;
    }
    &--header{
        border-bottom: 1px solid #E7EAEE;
        color: #323A46;
        font-weight: 600;
    }
    &--meaning,
    &--example{
        color: #64748B;
    }
}
</style>
